import {RegisterType} from '../component-registry';
import {GuidedUiFooterBanner} from '../../models/Guided.schema';
import {GuidedFooterBanner} from './guided-banner';
import {h} from '@stencil/core';
import type {GuidedV2FactoryState} from '../../models/ui';

export class GuidedV2FooterBanner {
  @RegisterType(GuidedUiFooterBanner.type)
  render(inputData: GuidedUiFooterBanner, state: Omit<GuidedV2FactoryState, 'results'>) {
      const {
        text,
        description,
        href,
        buttonText,
        src,
        target,
        name
      } = inputData; //comes from configuration

      const {
        eventEmitters,
      } = state;
      const bannerText = state.labelProvider(`guided-v2.banner.text.${name}`,text);
      const bannerDescription = state.labelProvider(`guided-v2.banner.description.${name}`,description);
      const bannerButtonText = state.labelProvider(`guided-v2.banner.buttonText.${name}`,buttonText);

      return <GuidedFooterBanner
        text={bannerText}
        href={href}
        description={bannerDescription}
        buttonText={bannerButtonText}
        src={src}
        eventEmitters={eventEmitters}
        target={target}
      ></GuidedFooterBanner>;
  }
}
